import { useContext } from "react"
import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from "react-router-dom"
import LoginScreen from "../pages/Login.js"
import DashBoard from "../pages/Dashboard.js"
import DashboardLayout from "../layout/DashboardLayout.js"
import UsersScreen from "../pages/UsersScreen.js"
import NotificationScreen from "../pages/Notification.js"
import { AuthProvider, AuthContext } from "../context/authContext.js"
import { SearchProvaider } from "../context/searchNameContext.js"
import NotificationDetail from "../pages/NotificationDetail.js"
import TeamScreen from "../pages/TeamScreen.js"
import Ajustes from "../pages/Ajustes.js"


function PrivateRoutes(){
    const {user, loading} = useContext(AuthContext)

    if (loading) {
        return <div>Cargando...</div>
    }
    console.log(user)

    return user?.id ? <Outlet/> : <Navigate to="/login" />
}

function App() {
    return (
        <AuthProvider>
            <SearchProvaider>
                <Router>
                <Routes>
                    <Route path="/login" element={<LoginScreen></LoginScreen>}/>
                        <Route element={<PrivateRoutes/>}>
                            <Route element={<DashboardLayout/>}>
                                <Route path="/" element={<DashBoard />} />
                                <Route path="/users" element={<UsersScreen />} />
                                <Route path="/notifications" element={<NotificationScreen />} />
                                <Route path="/notifications/:id/:sendemail" element={<NotificationDetail />} />
                                <Route path="/team" element={<TeamScreen />} />
                                <Route path="/ajustes" element={<Ajustes />}></Route>
                            </Route>
                        </Route>
                    </Routes>
                </Router>
            </SearchProvaider>     
        </AuthProvider>       
    )
}

export default App